import type { ComponentProps, ForwardRefExoticComponent, RefAttributes } from 'react'

import { DateTimePicker } from '@/components/ui/datetime.tsx'

import { EditableComponent } from '@/components/EditableComponent.tsx'
import { STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'
import { useMutateStoryAcceptedAt } from '@/requests/mutations/useMutateStoryAcceptedAt.ts'
import { useQueryProjectMeta } from '@/requests/queries/useQueryProject.ts'
import { getNow, toReadableDateTime } from '@/utils/date.ts'

type EditableVersionProps = {
  storyId: string
  value: number | null
  status: StoryStatus
}
export const EditableAcceptedAt = ({ storyId, status, value = getNow() }: EditableVersionProps) => {
  const {
    projectMeta: { createdAt },
  } = useQueryProjectMeta()
  const { mutate } = useMutateStoryAcceptedAt(storyId)

  if (status !== STORY_STATUSES.ACCEPTED) return null

  return (
    <>
      <DateTimePicker
        id={`accepted-at-${storyId}`}
        timestamp={value ?? getNow()}
        setTimestamp={(timestamp) => mutate(timestamp)}
        validator={(timestamp) => {
          if (timestamp < createdAt) throw new Error('Accepted date cannot be before project creation date')
          if (timestamp > getNow()) throw new Error('Accepted date cannot be in the future')
        }}
      />
      <div className="text-contents-primary font-EN-KR-body2-regular">
        Accepted on {value ? toReadableDateTime(value, false) : ''}
      </div>
    </>
  )
}

export const TypedEditableAcceptedAt = EditableComponent as unknown as ForwardRefExoticComponent<
  EditableProps<number, undefined, ComponentProps<typeof EditableAcceptedAt>> & RefAttributes<EditableCommands>
>
